import React from 'react';
import T from 'prop-types';

import AppInfo from '../../_shared/components/AppInfo';
import VelocityChange from '../../../../components/VelocityChange';

import { numberToPercentage } from '../../../../utils/formatter';

const metricsOptions = [
  { label: 'DAU', value: 'dau' },
  { label: 'MAU', value: 'mau' },
];

const PerformanceWidget = ({
  data,
  isMobileView,
}) => (
  <div className="performance-widget">
    {data.map((item, index) => (
      <div key={index} className="performance-widget__item">
        <AppInfo
          size={isMobileView ? 48 : 40}
          app={item}
          enableTooltip={!isMobileView}
        />
        <div className="performance-widget__item-stats">
          {metricsOptions.map(({ label, value }) => (
            <div key={value} className="performance-widget__item-stats-row">
              <span className="performance-metric-label">{label}</span>
              <div className="performance-metric-change">
                {numberToPercentage(item[value])}
                <VelocityChange change={item[value]} />
              </div>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

PerformanceWidget.propTypes = {
  data: T.arrayOf(
    T.shape({
      dau: T.number,
      mau: T.number,
      icon_url: T.string,
      name: T.string,
      ticker: T.string,
    }),
  ).isRequired,
  isMobileView: T.bool,
};

export default PerformanceWidget;
